import React from 'react'

const BALL = 'M64 112C90.5097 112 112 90.5097 112 64C112 37.4903 90.5097 16 64 16C37.4903 16 16 37.4903 16 64C16 90.5097 37.4903 112 64 112Z'
const BASKETBALL_SEAMS = 'M16 64H112M64 16V112M31 29C59 46 59 82 31 99M97 29C69 46 69 82 97 99'

/** Stroke paths per icon, drawn on a 128 grid. Filled dots are listed apart. */
const ICONS = {
  soccer: {
    strokes: [
      BALL,
      'M64 44L83 58M64 44L45 58M64 44V16M83 58L76 80M83 58L110 49M76 80H52M76 80L92 103M52 80L45 58M52 80L36 103M45 58L18 49',
    ],
  },
  basketball: { strokes: [BALL, BASKETBALL_SEAMS] },
  wnba: { strokes: [BALL, BASKETBALL_SEAMS] },
  tennis: { strokes: [BALL, 'M31 29C59 46 59 82 31 99M97 29C69 46 69 82 97 99'] },
  baseball: {
    strokes: [
      BALL,
      'M52 22C30 44 30 84 52 106M76 22C98 44 98 84 76 106',
      'M36 42L46 44M31 64L41 64M36 86L46 84M92 42L82 44M97 64L87 64M92 86L82 84',
    ],
  },
  'american-football': {
    strokes: [
      'M79.8976 89.4415C102.847 75.1009 114.334 52.0849 105.554 38.034C96.7744 23.9831 71.0523 24.218 48.1025 38.5586C25.1526 52.8993 13.6657 75.9152 22.4457 89.9661C31.2257 104.017 56.9478 103.782 79.8976 89.4415Z',
      'M19.797 76.2919C35.1673 72.5833 43.646 86.1521 33.5749 98.3411M94.4252 29.659C84.3541 41.848 92.8328 55.4168 108.203 51.7082M47.8871 74.0685L80.113 53.9316M47.5699 66.0125L54.9888 77.8852M56.0504 60.7133L63.4693 72.586M64.5309 55.4141L71.9497 67.2868M73.0114 50.1149L80.4302 61.9876',
    ],
  },
  hockey: {
    strokes: [
      'M37 17L79 81H108V92H76L29 22M96 17L56 79',
      'M43 107C52.9411 107 61 103.866 61 100C61 96.134 52.9411 93 43 93C33.0589 93 25 96.134 25 100C25 103.866 33.0589 107 43 107Z',
      'M25 100V109C25 118 61 118 61 109V100',
    ],
  },
  boxing: {
    strokes: [
      'M50 83C55 75 51 67 43 59C36 51 28 47 22 53C15 59 17 70 27 75C31 82 36 92 47 95M47 95V112H89V95M47 95H89M43 59V39C43 23 55 16 72 16C91 16 103 28 103 45V65C103 79 96 87 89 95',
    ],
  },
  formula1: {
    strokes: [
      'M16 84H26M48 84H79M103 84H112V64H102L94 49H74L61 69M61 69H27L20 84M61 69H102M78 49V38H98M16 69V53H30M16 59H40L51 69',
      'M37 97C43.6274 97 49 91.6274 49 85C49 78.3726 43.6274 73 37 73C30.3726 73 25 78.3726 25 85C25 91.6274 30.3726 97 37 97Z',
      'M91 97C97.6274 97 103 91.6274 103 85C103 78.3726 97.6274 73 91 73C84.3726 73 79 78.3726 79 85C79 91.6274 84.3726 97 91 97Z',
    ],
  },
  esports: {
    strokes: [
      'M34.0001 52V74M23.0001 63H45.0001M43.0001 37H85.0001C99.0001 37 106 46 109 60L115 86C118 103 103 108 94.0001 98L79.0001 82H49.0001L34.0001 98C25.0001 108 10.0001 103 13.0001 86L19.0001 60C22.0001 46 29.0001 37 43.0001 37Z',
    ],
    fills: [
      'M87 58C88.6569 58 90 56.6569 90 55C90 53.3431 88.6569 52 87 52C85.3431 52 84 53.3431 84 55C84 56.6569 85.3431 58 87 58Z',
      'M99 70C100.657 70 102 68.6569 102 67C102 65.3431 100.657 64 99 64C97.3431 64 96 65.3431 96 67C96 68.6569 97.3431 70 99 70Z',
    ],
  },
}

export const hasSportIcon = icon => Boolean(ICONS[icon])

/**
 * Line icon for a sport, tinted by its `--color-sport-*` token so it follows the
 * in-app theme. Renders nothing for a sport without a drawing.
 */
const SportIcon = ({ icon, className = 'h-4 w-4' }) => {
  const drawing = ICONS[icon]
  if (!drawing) return null

  return (
    <svg
      viewBox="0 0 128 128"
      fill="none"
      aria-hidden="true"
      className={`shrink-0 ${className}`}
      style={{ color: `var(--color-sport-${icon})` }}>
      {drawing.strokes.map(d => (
        <path key={d} d={d} stroke="currentColor" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round" />
      ))}
      {drawing.fills?.map(d => (
        <path key={d} d={d} fill="currentColor" />
      ))}
    </svg>
  )
}

export default SportIcon
